import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { parse } from 'date-fns'
import { checkInputErrorRequired, useDatePicker, useTimePicker } from '@chilecompra/react-kit'
import { Button, Dialog, TimePicker } from '@chilecompra/react-kit/components'
import { features } from '../../config/settings/features'
import Errors from '../../components/Custom/Errors'
import {
  onCleanUpBugsSuccess,
  onCloseQuoteExtendClosingDateDialog,
  onExtendQuoteClosingDateThunk,
  onResetChangeDateCloseSuccess
} from './ExtendQuoteClosingDateDialog.actions'
import { Column, DatePicker, Row, Title } from './ExtendQuoteClosingDateDialog.styles'

import { inIframe } from '../../modules/utils/inIframe'
import { topPage } from '../../modules/utils/topPage'

/**
 * The ExtendQuoteClosingDateDialog's container.
 */
const ExtendQuoteClosingDateDialog = () => {
  const dispatch = useDispatch()
  const { initData } = useSelector(state => state.quoteStepOne)
  const { errors, loading, open } = useSelector(state => state.extendQuoteClosingDateDialog)
  const {
    basicInfo: { dateClose }
  } = useSelector(state => state.quoteBasicInformation)

  const isInIframe = useMemo(() => inIframe(), [])

  const {
    error: dateError,
    value: dateValue,
    onChange: handleDateChange,
    setValue: setDateValue
  } = useDatePicker({
    errorCallbacks: [checkInputErrorRequired()],
    initialValue: dateClose ? parse(dateClose.substring(0, 10), 'dd-MM-yyyy', new Date()) : null
  })
  const {
    error: timeError,
    value: timeValue,
    onChange: handleTimeChange,
    setValue: setTimeValue
  } = useTimePicker({ errorCallbacks: [checkInputErrorRequired()] })
  const handleClose = useCallback(() => {
    dispatch(onCloseQuoteExtendClosingDateDialog())
    setDateValue(null)
    setTimeValue(null)
  }, [])
  const handleSubmit = useCallback(() => {
    dispatch(onExtendQuoteClosingDateThunk({ date: dateValue, time: timeValue }))
    setDateValue(null)
    setTimeValue(null)
  }, [dateValue, timeValue])
  const disableSubmit = useMemo(
    () => dateError !== '' || dateValue === null || timeError !== '' || timeValue === null,
    [dateError, dateValue, timeError, timeValue]
  )
  const maxDate = useMemo(
    () => (features['services.use.max.date'] && initData?.maxDate ? initData?.maxDate : undefined),
    [initData?.maxDate, features]
  )

  useEffect(() => {
    topPage(isInIframe, open)

    if (open) {
      dispatch(onResetChangeDateCloseSuccess())
    }
    dispatch(onCleanUpBugsSuccess())
  }, [open])

  return (
    <Dialog open={open} verticalAlign="top" onClose={handleClose}>
      <Row justifyContent="center" padding="53px 0 18px">
        <Title>Ampliar fecha de cierre</Title>
      </Row>
      <Row>
        <Column xs={12} sm={12} md={6} lg={6}>
          <DatePicker
            required
            error={dateError}
            label="Fecha"
            minDate={dateClose && parse(dateClose.substring(0, 10), 'dd-MM-yyyy', new Date())}
            maxDate={maxDate}
            value={dateValue}
            onChange={handleDateChange}
          />
        </Column>
        <Column xs={12} sm={12} md={6} lg={6}>
          <TimePicker error={timeError} label="Hora" onChange={handleTimeChange} required tiping value={timeValue} />
        </Column>
      </Row>
      <Row>
        <Column xs={12}>
          <Errors errors={errors} />
        </Column>
      </Row>
      <Row justifyContent="center" padding="14px 0 0">
        <Button color="success" disabled={disableSubmit} loading={loading} onClick={handleSubmit}>
          Confirmar ampliación de fecha
        </Button>
      </Row>
      <Row justifyContent="center" padding="10px 0 0">
        <Button variant="text" onClick={handleClose}>
          Cancelar
        </Button>
      </Row>
    </Dialog>
  )
}

export default ExtendQuoteClosingDateDialog
